export default __webpack_public_path__ + "static/media/golf.d507b298.png";